import React from 'react';
import { TextField } from '@mui/material';

function visibleRowCount(value, minRows, maxRows) {
  const lineCount = String(value ?? '').split('\n').length;
  return Math.min(maxRows, Math.max(minRows, lineCount));
}

export default function StableMultilineTextField({
  value,
  minRows = 1,
  maxRows = 4,
  InputProps,
  ...props
}) {
  return (
    <TextField
      {...props}
      value={value}
      multiline
      rows={visibleRowCount(value, minRows, maxRows)}
      InputProps={{
        ...InputProps,
        inputComponent: 'textarea',
      }}
    />
  );
}
